import API, { PROJECT_UUID_HEADER } from '../../../lib/commons/api'
import { GanttDisplayRangeMode } from '../../../domain/value-object/GanttParameterVO'

const PATH = '/api/v1/projects/user_gantt_setting'

export type UserProjectGanttSetting = {
  displayRangeMode: GanttDisplayRangeMode
}

export const toGanttDisplayRangeMode = (
  value: unknown
): GanttDisplayRangeMode =>
  value === GanttDisplayRangeMode.CONSTANT
    ? GanttDisplayRangeMode.CONSTANT
    : GanttDisplayRangeMode.REMEMBER

export const getUserProjectGanttSetting = async (
  projectUuid: string
): Promise<UserProjectGanttSetting> => {
  const response = await API.functional.request('GET', PATH, {}, true, null, {
    [PROJECT_UUID_HEADER]: projectUuid,
  })
  return {
    displayRangeMode: toGanttDisplayRangeMode(response.json?.displayRangeMode),
  }
}

export const updateUserProjectGanttSetting = async (
  projectUuid: string,
  displayRangeMode: GanttDisplayRangeMode
): Promise<UserProjectGanttSetting> => {
  const response = await API.functional.request(
    'PUT',
    PATH,
    { displayRangeMode },
    true,
    null,
    { [PROJECT_UUID_HEADER]: projectUuid }
  )
  return {
    displayRangeMode: toGanttDisplayRangeMode(response.json?.displayRangeMode),
  }
}
